import { FAILED_URLS } from "../lib/constants/actions";

export const getFailedUrls = (data) => {
    return { type: FAILED_URLS.GET_FAILED_URLS, payload: data }
}

export const failedUrlsSuccess = (data) => {
    return { type: FAILED_URLS.GET_FAILED_URLS_SUCCESS, payload: data }
}


export const getFailedUrlsFrequency = (data) => {
    return { type: FAILED_URLS.GET_FAILED_URLS_FREQUENCY, payload: data }
}

export const failedUrlsFrequencySuccess = (data) => {
    return { type: FAILED_URLS.GET_FAILED_URLS_FREQUENCY_SUCCESS, payload: data }
}












